import { DEVICE_ATTR } from 'const';

export function validateIPv4(str) {
  const parts = str.split(".");
  if (parts.length !== 4) return false;

  for (const p of parts) {
    if (!/^\d+$/.test(p)) return false;

    const num = Number(p);
    if (num < 0 || num > 255) return false;
  }

  return true;
}

export function validateDeviceAccount(userName, allowSpace = false) {
  const ERROR_MSG = "error";

  if (!userName) return { valid: false, msg: ERROR_MSG };

  if (userName.length < 1 || userName.length > 32)
    return { valid: false, msg: ERROR_MSG };

  const spaceRule = allowSpace ? "" : "\\s"; // 判斷是否能打空白 預設不能打
  const regex = new RegExp(`^(root|daemon|ftp|network|nobody|dnsmasq)$|[?${spaceRule}]`);
  if (regex.test(userName))
    return { valid: false, msg: ERROR_MSG };

  return { valid: true, msg: "" };
}

export function validateDeviceAccountPassword(pw, userName) {
  const ERROR_MSG = "Use 8–30 characters with a mix of upper/lowercase letters, numbers, and symbols. Avoid consecutive characters.";

  if (!pw) return { valid: false, msg: ERROR_MSG };
  // Length: Must be 8 to 30 characters long.
  if (pw.length < 8 || pw.length > 30)
    return { valid: false, msg: ERROR_MSG };
  //  Cannot contain ? (question mark) or spaces.
  if (/[?\s]/.test(pw))
    return { valid: false, msg: ERROR_MSG };
  // Cannot be the same as the user name.
  if (pw === userName)
    return { valid: false, msg: ERROR_MSG };
  // Cannot be the same as default login accounts (e.g., "admin")
  if (['admin'].includes(pw.toLowerCase()))
    return { valid: false, msg: ERROR_MSG };
  // Cannot be the same as  Ipv4 addresss.
  if (validateIPv4(pw))
    return { valid: false, msg: ERROR_MSG };
  // At least one uppercase alphabet (A-Z)
  if (!/[A-Z]/.test(pw))
    return { valid: false, msg: ERROR_MSG };
  // At least one lowercase alphabet (a-z)
  if (!/[a-z]/.test(pw))
    return { valid: false, msg: ERROR_MSG };
  // At least one number (0-9)
  if (!/[0-9]/.test(pw))
    return { valid: false, msg: ERROR_MSG };
  // Allowed Special Characters: ~ ! @ # $ ^ & * { } [ ] ( ) _ - + = . | : ; " ' < , > / \
  const specialPattern = /[-~!@#\$^&\*\{\}\[\]\(\)_\+=\.\|:;"'<,>\/\\]/;

  if (!specialPattern.test(pw))
    return { valid: false, msg: ERROR_MSG };
  // Must be non-consecutive characters (e.g., "1111", "aaaa" are not allowed).
  if (/(.)\1/.test(pw))
    return { valid: false, msg: ERROR_MSG };

  return { valid: true, msg: "" };
}

export function validDomainName(inputString) {
  const domainNameRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)+([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$/;
  return domainNameRegex.test(inputString);
}

export function validUrl(inputString) {
  const urlRegex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?([a-zA-Z0-9][a-zA-Z0-9.-]*[a-zA-Z0-9]\.)[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9](:[0-9]{1,5})?(\/[a-zA-Z0-9.-]*)*(\?[a-zA-Z0-9=&]*)?(#[a-zA-Z0-9.-]*)?$/;
  return urlRegex.test(inputString);
}

/**
* 解析 VLAN 字串（如 "1-10", "4,5,6-10", "1"）為 VLAN ID 陣列
*/
export function parseVlanString(vlanStr) {
  const ids = new Set();
  if (!vlanStr || vlanStr === "-") return ids;

  const segments = String(vlanStr).split(",");

  for (const seg of segments) {
    const trimmed = seg.trim();
    const rangeMatch = trimmed.match(/^(\d+)-(\d+)$/);

    if (rangeMatch) {
      const start = parseInt(rangeMatch[1], 10);
      const end = parseInt(rangeMatch[2], 10);
      for (let i = start; i <= end; i++) ids.add(i);
    } else if (/^\d+$/.test(trimmed)) {
      ids.add(parseInt(trimmed, 10));
    }

  }

  return ids;
}

export function validateIgmpVlan(value) {
  if (typeof value !== "string") {
    return false;
  }

  const trimmedValue = value.trim();

  if (!trimmedValue) {
    return false;
  }

  const segments = trimmedValue.split(",");

  for (const segment of segments) {
    const vlan = segment.trim();

    // 單一 VLAN，例如 "1"、"7"、"4094"
    if (/^\d+$/.test(vlan)) {
      const vlanId = Number(vlan);

      if (vlanId < 1 || vlanId > 4094) {
        return false;
      }

      continue;
    }

    // VLAN range，例如 "1-4"、"10-11"
    const rangeMatch = vlan.match(/^(\d+)-(\d+)$/);

    if (rangeMatch) {
      const start = Number(rangeMatch[1]);
      const end = Number(rangeMatch[2]);

      if (
        start < 1 ||
        start > 4094 ||
        end < 1 ||
        end > 4094 ||
        start > end
      ) {
        return false;
      }

      continue;
    }
    return false;
  }

  return true;
}

/**
* 根據 device model 計算其 所有 port 使用的 VLAN ID 數量與清單
* - SWITCH :
* - 1. access port：只計算 PVID
* - 2. trunk port：計算 PVID + allowVlan
* - AP :
* - 不管 access / trunk port 都要計算 PVID + allowVlan
*/
export function calcVlanIdsCountByDevice(ports, port) {
  const result = {
    number: 0,
    list: [],
  }

  if(!ports || !port) return result;

  const replacementPorts = ports.map(loopPort => {
    if(loopPort.portIndex === port.portIndex) return port;
    else return loopPort;
  })

  const vlanSet = new Set();

  for (const port of replacementPorts) {
    if (port?.PVID != null) {
      vlanSet.add(Number(port.PVID));
    }

    const deviceType = port.deviceType ?? port?.deviceCategory;

    const isSwitch = deviceType === DEVICE_ATTR.types.SW.toLowerCase();
    const isAccessPoint = deviceType === DEVICE_ATTR.types.AP.toLowerCase();

    if (isSwitch && port?.portType?.toLowerCase() === "trunk" && port?.allowVlan) {
      const vlanIds = parseVlanString(port.allowVlan);
      for (const id of vlanIds) vlanSet.add(id);
    } else if (isAccessPoint && port?.allowVlan){
      const vlanIds = parseVlanString(port.allowVlan);
      for (const id of vlanIds) vlanSet.add(id);
    }
  }

  const list = Array.from(vlanSet).sort((a, b) => a - b);
  result.list = list;
  result.number = list.length;

  return result;
}
